export { default } from './OpenFinanceVantagens';
